module.exports = __webpack_public_path__ + "media/images/flags/MN-c11483f25422c8bb4b0bcd3a0b9906f5.svg";